import { styled, Box, Stack, Chip } from "@mui/material";

export const ExportOptionsRoot = styled(Box)(({ theme, show }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  width: "100%",
}));

export const ExportOptionsBlock = styled(Box)(({ theme, divider }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexWrap: "wrap",
  position: "relative",
  padding: "1rem 0 2rem",
  width: "100%",
}));

export const ExportOptionsStack = styled(Stack)(({ theme, columns }) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, auto)`,
  justifyContent: "flex-start",
  alignItems: "flex-start",
  flexWrap: "wrap",
  gap: "0.75rem 0.75rem",
  [theme.breakpoints.up("xl")]: {
    gap: "0.85rem 0.75rem",
  },
}));

export const ExportOptionsChip = styled(Chip)(({ theme, selected }) => ({
  fontSize: "1.25rem",
  padding: "1px 5px",
  marginLeft: "0 !important",
  lineHeight: 1.25,
  height: 25,
  boxShadow: "0px 0px 5px rgba(0,0,0,0.2)",
  color: selected
    ? theme?.palette?.companyColors?.secondary
    : theme?.palette?.companyColors?.primary,
  background: selected
    ? theme?.palette?.companyColors?.accent
    : theme?.palette?.companyColors?.greyLight1,
  svg: {
    fill: selected
      ? theme?.palette?.companyColors?.secondary
      : theme?.palette?.companyColors?.secondary,
  },
  ".MuiChip-label": {
    marginTop: 2,
  },
}));
